const ReportWebNew = () => {
  return <div>ReportWebNew</div>
}

export default ReportWebNew
